import { useRefData } from '../lib/reference';

/** Language code on a coloured background (colour set in Lists > Languages; FR blue, EN red, PT green, ES orange). */
export function LangBadge({ code }: { code: string | null | undefined }) {
  const { lists } = useRefData();
  if (!code) return null;
  const lang = lists?.languages.find((l) => String(l.code).toUpperCase() === code.toUpperCase());
  const color = lang?.color ? String(lang.color) : null;
  return (
    <span className={`badge lang-badge ${color ? 'colored' : ''}`} style={color ? { background: color, borderColor: color } : undefined} title={lang ? String(lang.label) : undefined}>
      {code}
    </span>
  );
}
